/**
 * TableCountDropdown
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { updateQueryString } from '../../services/router/actions';

// Workspaces
import { makeSelectQueryStringNumberValue } from '../../workspaces/react-router-selectors';

interface Props {
    updateQueryString: Function;
    count?: number;
    defaultCount: number;
    namespace?: string;
}

export class TableCountDropdown extends React.PureComponent<Props> {
    static defaultProps = {
        defaultCount: 5
    };

    handleChange = (
        event: SyntheticInputEvent<EventTarget>,
        data: { value: number }
    ) => {
        const { namespace } = this.props;

        this.props.updateQueryString({
            [`${namespace ? `${namespace}_` : ''}count`]: data.value,
            [`${namespace ? `${namespace}_` : ''}page`]: undefined
        });
    };

    render() {
        const { count, defaultCount } = this.props;

        return (
            <div style={{ display: 'inline-block' }}>
                <Dropdown
                    selection
                    value={count || defaultCount}
                    options={[
                        {
                            key: 5,
                            text: '5 Rows',
                            value: 5
                        },
                        {
                            key: 10,
                            text: '10 Rows',
                            value: 10
                        },
                        {
                            key: 25,
                            text: '25 Rows',
                            value: 25
                        },
                        {
                            key: 50,
                            text: '50 Rows',
                            value: 50
                        },
                        {
                            key: 100,
                            text: '100 Rows',
                            value: 100
                        }
                    ]}
                    onChange={this.handleChange}
                />
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    count: (state, props) => {
        const { namespace } = props;
        return makeSelectQueryStringNumberValue(
            `${namespace ? `${namespace}_` : ''}count`
        )(state, props);
    }
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(TableCountDropdown);
